import { cn } from '@/lib/utils';
import { ONBOARDING_STEPS, type OnboardingStep, stepIndex } from './wizardState';

const LABELS: Record<OnboardingStep, string> = {
  email: 'E-mail',
  profile: 'Perfil',
  cnpj: 'CNPJ',
};

export function ProgressBar({ current }: { current: OnboardingStep }) {
  const currentIdx = stepIndex(current);
  const total = ONBOARDING_STEPS.length;
  const pct = Math.round(((currentIdx + 1) / total) * 100);

  return (
    <div className="mb-8">
      <div className="mb-3 flex items-center justify-between text-xs text-(--color-fg-muted)">
        <span>
          Passo {currentIdx + 1} de {total}
        </span>
        <span>{pct}%</span>
      </div>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        className="h-1.5 w-full overflow-hidden rounded-full bg-(--color-border)"
      >
        <div
          className="h-full rounded-full bg-(--color-accent) transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
      <ol className="mt-3 grid grid-cols-3 gap-2 text-xs">
        {ONBOARDING_STEPS.map((step, i) => (
          <li
            key={step}
            className={cn(
              'text-center',
              i <= currentIdx ? 'text-(--color-fg)' : 'text-(--color-fg-muted)',
            )}
          >
            {LABELS[step]}
          </li>
        ))}
      </ol>
    </div>
  );
}
